import SectionTitleReveal from '../common/section-title-reveal';

export default class OpenClose {
    constructor() {
        this.sections = document.querySelectorAll('.block-open-close');
        this.ready();
    }

    ready() {
        this.sections.forEach((section) => {
            const AllItemsContainers = section.querySelectorAll('.open-close-items');
            AllItemsContainers.forEach((items) => {
                const allItems = items.querySelectorAll('.block-open-close-item .title');
                allItems.forEach((question) => {
                    question.addEventListener('click', () => {
                        const item = question.parentElement;
                        const panel = item.querySelector('.item-block');
                        const isOpen = item.classList.toggle('active');

                        question.setAttribute('aria-expanded', String(isOpen));
                        panel?.setAttribute('aria-hidden', String(!isOpen));

                        if (isOpen) {
                            panel?.removeAttribute('inert');
                        } else {
                            panel?.setAttribute('inert', '');
                        }
                    });
                });
            });
        });
    }
}

new SectionTitleReveal('.block-open-close');

if (document.querySelector('.block-open-close')) {
    new OpenClose();
}
